export const BOOKING_TYPE_CALENDAR_TIMESLOTS = 'CALENDAR-TIMESLOTS';

export const EXP_ANY_DATE = 'any';

export const TITLE = 'title';
export const IMAGES = 'images';

export const THINGS_TO_KNOW = 'thingsToKnowNew';

export const DEAL_DESCRIPTION = 'dealDescription';
export const SHORT_DESCRIPTION = 'shortDescription';
export const INCLUDED = 'included';

export const curationCommentOptions = [
  { value: '', label: 'None' },
  { value: 'Directly Contracted', label: 'Directly Contracted' },
  { value: 'Quality Concerns', label: 'Quality Concerns' },
  { value: 'Tech Issue', label: 'Tech Issue' },
  { value: 'CX Complaints', label: 'CX Complaints' },
  { value: 'Availability Issue', label: 'Availability Issue' },
  { value: 'Commercial Request', label: 'Commercial Request' },
  { value: 'Margin Checked', label: 'Margin Checked' },
];

export const EXP_CATEGORY_ID_AIRPORT_LOUNGE = 46;
